<template>
  <div class="login-container">
    <div class="logo">
      <img id="logoImg" :src="logoSrc">
    </div>
    <!-- 登录 -->
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" autocomplete="on" class="login-form"
      label-position="left">
      <div class="title-container">
        <h3 class="title">{{ systemTitle }}{{ $t('login.title') }}</h3>
        <lang-select class="set-language" />
      </div>

      <el-form-item prop="username">
        <span class="svg-container">
          <i class="el-icon-user"></i>
        </span>
        <el-input ref="username" v-model="loginForm.username" :placeholder="$t('login.userName')" autocomplete="on"
          name="username" tabindex="1" type="text" />
      </el-form-item>

      <el-tooltip v-model="capsTooltip" content="Caps lock is On" manual placement="right">
        <el-form-item prop="password">
          <span class="svg-container">
            <i class="el-icon-lock"></i>
          </span>
          <el-input :key="passwordType" ref="password" v-model="loginForm.password" :placeholder="$t('login.password')"
            :type="passwordType" autocomplete="on" name="password" tabindex="2" @blur="capsTooltip = false"
            @keyup.enter.native="handleLogin" @keyup.native="checkCapslock" />
          <span class="show-pwd" @click="showPwd">
            <i v-if="passwordType != 'password'" class="el-icon-view"></i>
            <img v-else src="../../assets/icon/close-eye.png" alt="" style="width: 18px;">
          </span>
        </el-form-item>
      </el-tooltip>

      <!-- 正常登录 -->
      <el-button :loading="loading" style="width:100%;margin-bottom:20px;height: 45px;" type="primary"
        @click.native.prevent="handleLogin">{{ $t('login.Login') }}</el-button>

      <!-- trionic登录 -->
      <el-button v-if="isGPD && !isGemone" :loading="loading" type="primary" id="visitorLogIn"
        style="width:100%;margin-bottom:30px;height: 45px;margin-left:0; " @click.native.prevent="visitorLogin">
        {{ $t('login.visitorLogIn') }}
      </el-button>
    </el-form>

    <div class="icp_slot">
      <icp-link></icp-link>
    </div>

    <!-- drm跳转指引 -->
    <div class="drm_guide" v-if="showGuide">
      <div class="content">
        <div class="close_box" @click="replaceHome"><i class="el-icon-close click"></i></div>
        <div class="hi">Hi, {{loginForm.username}}</div>
        <div class="slogan">{{$t('drmAd.slogan')}}</div>
        <div class="sys_name">
          <img class="img_drm" src="./imgs/drm.png" alt="DRM">
          <span>{{$t('drmAd.sys')}}</span>
        </div>
        <div class="short_line"></div>
        <div class="btn_box">
          <p class="click sure" @click="replaceDrm">{{$t('drmAd.experience')}}</p>
          <p class="click cancel" @click="replaceHome">{{$t('drmAd.try_later')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LangSelect from '@/components/LangSelect'
var Base64 = require('js-base64').Base64
import { webInfo } from '@/api/user'
import IcpLink from '@/components/IcpLink.vue'

export default {
  name: 'Login',
  components: { LangSelect, IcpLink },
  data () {
    const validateUsername = (rule, value, callback) => {
      // if (!validUsername(value)) {
      //   callback(new Error('Please enter the correct user name'))
      // } else {
      callback()
      // }
    }
    const validatePassword = (rule, value, callback) => {
      // if (value.length < 6) {
      //   callback(new Error('The password can not be less than 6 digits'))
      // } else {
      callback()
      // }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},

      selectedLanguage: '',
      selectedMap: '',
      selectedTimeZone: '',
      systemTitle: '',
      logoSrc: '',
      showGuide: false
    }
  },
  computed: {
    routes () {
      return this.$router.options.routes
    },
    language () {
      console.log(this.$store.state.language)
      if (this.$store.state.language === 'zh') {
        console.log('zh')
        this.$store.dispatch('setMap', 'gdMap')
      } else {
        this.$store.dispatch('setMap', 'ggMap')
      }
      return this.$store.state.language
    },
    isGPD () {
      return location.href.indexOf('localhost') >= 0 || location.href.indexOf('gpdcloud') >= 0
    },
    isGemone () {
      return location.href.indexOf('gemone') >= 0
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        console.log('路由替换--', query)
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  created () {
    this.setTitleIco()
  },
  mounted () {
    console.log(location.href.indexOf('localhost') >= 0)
    if (this.loginForm.username === '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password === '') {
      this.$refs.password.focus()
    }
  },
  destroyed () {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    setTitleIco () {
      webInfo().then(res => {
        console.log('客户信息：', res)
        if (res.resultCode == 1001) {
          if (res.resultModel) this.$store.dispatch('setWebInfo', res.resultModel)
          var webInfo = res.resultModel || {}
          this.systemTitle = webInfo.siteName ? webInfo.siteName : 'GPD'
          document.title = this.systemTitle + this.$t('login.title')
          this.logoSrc = webInfo.logo ? webInfo.logo : require('@/assets/icon/logo.png')
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = ''
          if (webInfo.ico) {
            link.href = webInfo.ico
            document.getElementsByTagName('head')[0].appendChild(link)
          }
        }
      })
    },
    checkCapslock ({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if ((shiftKey && key >= 'a' && key <= 'z') || (!shiftKey && key >= 'A' && key <= 'Z')) {
          this.capsTooltip = true
        } else {
          this.capsTooltip = false
        }
      }
      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false
      }
    },
    showPwd () {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    replaceDrm () {
      location.replace('https://drm.gpdcloud.net/#/?from=gpdCloud&lang=' + this.getCurrentLang())
    },
    getCurrentLang () {
      let lang = this.$i18n.locale
      if (lang == 'zh') lang = 'zh_CN'
      if (lang == 'ft') lang = 'zh_HK'
      if (lang == 'kl') lang = 'ko'
      return lang
    },
    replaceHome () {
      this.$router.push({
        path: this.redirect || '/',
        query: this.otherQuery
      })
    },
    // 登录成功处理
    loginSuccHandle () {
      var localUtc = new Date().getTimezoneOffset() / 60
      if (this.$store.state.language === 'zh') {
        this.$store.dispatch('setMap', 'gdMap')
      } else {
        this.$store.dispatch('setMap', 'ggMap')
      }
      this.$store.dispatch('setTimezone', -localUtc)

      // if (this.isGPD) {
      //   this.showGuide = true
      // }else {
      this.replaceHome()
      // }

    },
    handleLogin () {
      console.log('login-')
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          var form = JSON.parse(JSON.stringify(this.loginForm))
          form.password = Base64.encode(form.password)
          this.$store.dispatch('login', form).then(() => {
            this.loginSuccHandle()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    visitorLogin () {
      this.loginForm = {
        username: 'guest',
        password: 'guest'
      }
      this.handleLogin()

    },
    getOtherQuery (query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}
.logo {
  display: inline-block;
  margin: 30px;
}
.downListDiv {
  display: inline-block;
  height: 40px;
  margin-left: 15px;
}
.downListImg {
  height: 30px;
  margin-top: 5px;
}
.downListSelect {
  height: 34px;
  // width: 100px;
  font-size: 14px;
  color: #909399;
  height: 34px;
  vertical-align: top;
  margin-top: 5px;
}
.iconStyle {
  background: white;
  padding: 5px;
  font-size: 20px;
  border-radius: 5px;
}
/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;
  position: relative;

  .login-form {
    width: 520px;
    // height:340px;
    // background:#eff1f4;
    max-width: 100%;
    padding: 0 35px;
    margin: 0 auto;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      color: #fff;
      padding-top: 20px;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }

    .set-language {
      color: #fff;
      position: absolute;
      top: 3px;
      font-size: 18px;
      right: 0px;
      cursor: pointer;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}

// drm 跳转指引
.drm_guide {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba($color: #000, $alpha: 0.2);
  .content {
    background-color: #fff;
    width: 40%;
    height: 460px;
    border-radius: 10px;
    box-shadow: 0 0 4px 4px #283443;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    padding-left: 50px;
    background-image: url("./imgs/drm_guide_back.png");
    background-size: 70% auto;
    background-position: right;
    background-repeat: no-repeat;
  }

  .close_box {
    text-align: right;
    font-size: 30px;
    padding: 10px;
    color: #707070;
  }
  .hi {
    font-size: 24px;
    font-weight: bold;
    color: #000;
  }
  .slogan {
    font-size: 18px;
    color: #000;
    margin: 20px 0;
    padding-right: 36%;
    line-height: 32px;
  }
  .sys_name {
    height: 36px;
    overflow: hidden;
    font-size: 26px;
    font-weight: bold;
    color: #000;
    span {
      vertical-align: top;
    }
    .img_drm {
      width: 70px;
      margin-top: -20px;
    }
  }
  .short_line {
    width: 30px;
    border-top: 2px solid #80bd01;
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .btn_box {
    width: 280px;
    text-align: center;
    .sure {
      background-color: #80bd01;
      color: #fff;
      font-size: 24px;
      margin-bottom: 20px;
      border-radius: 6px;
      padding: 10px 0;
    }
    .cancel {
      color: #999;
    }
  }
}

.icp_slot {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}
</style>
